/*
  kp-header-menu.js — hover-intent for the desktop nav (ADR 0002).

  Dawn's <header-menu> is a click disclosure. On a mouse, Baymard's finding
  is that a menu should also open on hover, with 300–500ms of intent so a
  cursor crossing the bar does not flicker every panel open. This script
  only ever sets and clears the <details> `open` attribute Dawn already
  owns; click, ESC, focus-out and StickyHeader's close all keep working.

  Touch and keyboard never reach this: it is gated on (pointer: fine) and
  on the pointer type of the event.
*/
(() => {
  if (!window.matchMedia('(pointer: fine)').matches) return;

  const OPEN_DELAY = 350;
  const CLOSE_DELAY = 250;

  const menus = Array.from(document.querySelectorAll('.header__inline-menu header-menu'));
  if (!menus.length) return;

  const closeOthers = (current) => {
    menus.forEach((menu) => {
      if (menu !== current && menu.mainDetailsToggle.open) menu.close();
    });
  };

  menus.forEach((menu) => {
    const details = menu.mainDetailsToggle;
    const summary = details.querySelector('summary');
    let timer;

    menu.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        if (details.open) return;
        closeOthers(menu);
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }, OPEN_DELAY);
    });

    menu.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        // Keyboard focus inside the panel wins over the cursor leaving it.
        if (details.open && !menu.contains(document.activeElement)) menu.close();
      }, CLOSE_DELAY);
    });

    // A click while the open timer is pending would open then immediately
    // toggle — clear the timer so the click is the only opinion.
    summary.addEventListener('pointerdown', () => window.clearTimeout(timer));
  });
})();
